import React from "react";

import Box from "../Box";

const Bloger = props => {
  return (
    <section className="hp__block hp__block--bloger container">
      <Box {...props} id="b1" type="bloger" settings={props.settings.b1} />
    </section>
  );
};

export default Bloger;
